import { createAsyncThunk } from '@reduxjs/toolkit';

import { asyncPayloadCreator } from 'utils';

import { AccountService } from 'api';

import {LoginOTPProps} from 'models/api';

export const loginOTP = createAsyncThunk(
	'authorization/loginOTP',
	(credentials: LoginOTPProps, { rejectWithValue }) =>
		asyncPayloadCreator(credentials, { rejectWithValue }, AccountService.loginOtp),
);
